import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { SourceOutputDTO } from './sourceDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class SourceServices {
  async getByAll(): Promise<SourceOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/source/`, {
        headers: { 'authentication-token': getJWT()! },
        params: {
          limit: 999,
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const sourceServices = new SourceServices()
